module.exports = __webpack_public_path__ + "static/media/shape.ab5fc1ea.svg";